import React from 'react';
import * as s from './CustomProgressBar.Styles';

const CustomProgressBar = ({config,height}) => {
    return (
        <s.ProgressContainer height={height}>
            {config.map((item, index) => {
                return (
                    <s.ProgressFilterSytle key={index} bgcolor={item.bgcolor} completed={item.completed}>
                        <div className='vertical-center'>
                            <s.LabelStyle>{item.completed} %</s.LabelStyle>
                        </div>
                    </s.ProgressFilterSytle>
                );
            })}
            
        </s.ProgressContainer>
    );
}

export default CustomProgressBar